export default "__VITE_ASSET__Bnov9rA7__"